
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/[cartUrl]/retrieve-previous-orders",
      function () {
        return require("private-next-pages/store/[cartUrl]/retrieve-previous-orders/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/[cartUrl]/retrieve-previous-orders"])
      });
    }
  